import { Controller, useFormContext, FieldError } from "react-hook-form";

import HexInput from "containers/admin/clients/client/theme-page/preview/components/hex-input/hex-input";
import { useButtonContent } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/use-button-content";
import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import { CUSTOM_VALUE } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button.constants";
import { ButtonKeys } from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";

interface CustomColorProps {
  section: ButtonKeys;
  label: string;
}

const CustomButtonColor = ({ section, label }: CustomColorProps) => {
  const { isEditMode } = useThemePreviewContext();
  const { control, clearErrors } = useFormContext();
  const { handleCustomChange, getSectionErrors } = useButtonContent();

  return (
    <Controller
      name={`button.${section}.custom`}
      control={control}
      render={({ field }) => (
        <div className="mt-2">
          <HexInput
            label={label}
            isRequired={true}
            isDisabled={!isEditMode}
            handleCustomChange={(value, isColorPickerInvoked) => {
              if (isColorPickerInvoked) clearErrors(`button.${section}.custom`);
              handleCustomChange(value, section, CUSTOM_VALUE, field.onChange);
            }}
            errMessage={(getSectionErrors(section)?.custom as FieldError)?.message}
            inputNameKey={CUSTOM_VALUE}
            {...field}
          />
        </div>
      )}
    />
  );
};

export default CustomButtonColor;
